<template>
  <!-- 事件属性管理 -->
  <div :class="['app-container', { 'bdc-list-page': isBdc, 'bdc-operate-aide-page': isBdc }]">
    <div class="chart-container">
      <el-row :gutter="20">
        <el-col :span="24" style="margin-bottom:10px;background:#fff">
          <div class="grid-content" style="float: left;width: 100%;position:relative;">
            <div class="ibox-title" style="float: left;width: 100%;">
              <span style="float:left;">
                <h5>事件属性管理<el-tooltip class="item" effect="dark" content="在该页面进行事件属性的管理。包括设置事件属性的显示名、显示状态等功能" placement="right">
                    <bdc-help-icon style="margin-left:20px;margin-bottom: 0px;" />
                  </el-tooltip>
                </h5>
              </span>
            </div>
            <div style="float:left;width: 100%;">
              <el-select v-model="tiaojian1.sysType" placeholder="属性类型" size="mini" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" @change="eventshaixuaneventTypeselect">
                <el-option label="全部事件属性" value="" />
                <el-option label="公共事件属性" value="0" />
                <el-option label="自定义事件属性" value="1" />
                <el-option label="虚拟事件属性" value="2" />
              </el-select>
              <el-input v-model="tiaojian1.findStr" size="mini" style="width:260px;float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" placeholder="参数名/参数显示名/参数描述模糊查询" clearable />
              <el-button type="primary" size="mini" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px" @click="mohuchaxun">查询</el-button>

              <el-table :stripe="!isBdc" :header-cell-style="isBdc ? undefined : {background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" :data="tableData1.slice((currentPage1-1)*sizePage1,currentPage1*sizePage1)" :class="isBdc ? 'grayTableTile bdc-crosshair-table' : 'tb-edit tb-edit1'" style="width: 100%" border @filter-change="filterplatformType" @sort-change="handleAgeSortChangeeventdata" @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
                <el-table-column prop="dataKey" label="参数名" min-width="120" sortable="custom">
                  <template slot-scope="scope">
                    <span style="color:#646cf5;cursor: pointer;" @click="chakanxiangqing(scope.$index, scope.row)">
                      <span v-if="scope.row.sysType == '2'">#vp@</span>{{ scope.row[scope.column.property] }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="dataName" label="显示名" min-width="150" show-overflow-tooltip sortable="custom">
                  <template slot-scope="scope">
                    <div style="font-size:12px;float: left;width: 90%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ scope.row[scope.column.property] }}</div>
                    <el-popover placement="bottom" width="410" trigger="click">
                      <el-input v-model="bjnametext" style="width:320px;" size="mini" />
                      <el-button type="primary" size="mini" @click="bianjiname(scope.$index,scope.row)">确定</el-button>
                      <div slot="reference" class="bianjisty" @click.stop="bjnametext=scope.row.dataName"><i class="el-icon-edit" style="color:#1890ff;cursor: pointer;" /></div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column prop="dataDesc" label="参数描述" show-overflow-tooltip min-width="200" sortable="custom" />
                <el-table-column prop="ruleText" label="校验规则" show-overflow-tooltip min-width="120" sortable="custom" />
                <el-table-column prop="dataType" label="数据类型" min-width="100" :filters="dataTypeslist" :filter-multiple="false" column-key="dataType" filter-placement="bottom-end">
                  <template slot-scope="scope">
                    {{ scope.row[scope.column.property] | dataTypes(dataTypeslist) }}
                  </template>
                </el-table-column>
                <el-table-column prop="sysType" label="属性类型" min-width="120" :filters="[ { text: '公共属性', value: '0' }, { text: '自定义属性', value: '1' }, { text: '虚拟属性', value: '2' }]" :filter-multiple="false" column-key="sysType" filter-placement="bottom-end">
                  <template slot-scope="scope">
                    <span v-if="scope.row.sysType == '1'">自定义属性</span>
                    <span v-if="scope.row.sysType == '0'">公共属性</span>
                    <span v-if="scope.row.sysType == '2'">虚拟属性</span>
                  </template>
                </el-table-column>
                <el-table-column prop="dataEmpty" label="是否必填" min-width="100" :filters="[ { text: '是', value: '1' }, { text: '否', value: '0' }]" :filter-multiple="false" column-key="dataEmpty" filter-placement="bottom-end">
                  <template slot-scope="scope">
                    {{ scope.row[scope.column.property] | dataEmptys }}
                  </template>
                </el-table-column>
                <el-table-column prop="isShow" label="显示状态" min-width="100" :filters="[ { text: '显示', value: true }, { text: '隐藏', value: false }]" :filter-multiple="false" column-key="isShow" filter-placement="bottom-end">
                  <template slot-scope="scope">
                    <el-switch v-model="scope.row[scope.column.property]" active-color="#13ce66" inactive-color="#ff4949" @change="bianjixianshi($event,scope.$index, scope.row)" />
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="是否生效" min-width="130" :filters="[{text: '生效', value: 1}, {text: '未生效', value: 0}, {text: '添加中', value: 2}]" :filter-multiple="false" column-key="status">
                  <template slot="header" slot-scope="scope">
                    <span class="bdc-table-header-with-tip">
                      是否生效
                      <el-tooltip class="item" effect="dark" content="代表该属性是否已被BDC维护入库；属性生效后才可正常查询，且生效属性不能删除。" placement="right">
                        <span class="bdc-table-header-tip-trigger">
                          <bdc-help-icon />
                        </span>
                      </el-tooltip>
                    </span>
                  </template>
                  <template slot-scope="scope">
                    <span>{{ {0: '未生效', 1: '生效', 2: '添加中'}[scope.row[scope.column.property]] }}</span>
                  </template>
                </el-table-column>

                <!-- 必传校验 -->
                <el-table-column prop="isCheck" column-key="isCheck" :filters="[{text: '校验', value: true}, {text: '不校验', value: false}]" label="必传校验" :filter-multiple="false" min-width="130">
                  <template slot="header" slot-scope="scope">
                    <span class="bdc-table-header-with-tip">
                      必传校验
                      <el-tooltip class="item" effect="dark" placement="right">
                        <div slot="content">用于标记属性是否为事件下的必传字段；<br />开启时，会在日志查看的格式校验中校验该属性是否上传；<br />关闭时，则不会校验，即事件中没有上传该属性也不会提示缺少参数。</div>
                        <span class="bdc-table-header-tip-trigger">
                          <bdc-help-icon />
                        </span>
                      </el-tooltip>
                    </span>
                  </template>
                  <template slot-scope="scope">
                    <el-switch :disabled="scope.row.sysType != '1'" v-model="scope.row[scope.column.property]" active-color="#13ce66" inactive-color="#ff4949" @change="bianjiCheck($event,scope.$index, scope.row)" />
                  </template>
                </el-table-column>

                <el-table-column label="操作" width="160">
                  <template slot-scope="scope">
                    <div class="bdc-table-op-cell">
                      <el-button type="text" class="bdc-table-op-muted" @click="bianjishijianshuxing(scope.$index, scope.row)">编辑</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <bdc-table-footer>
                <template #actions>
                  <bdc-download-button @click="exportExcel($event)" />
                </template>
                <pagination
                  v-show="dataLength1 > 0"
                  :auto-scroll="false"
                  :background="!isBdc"
                  :total="dataLength1"
                  :page.sync="currentPage1"
                  :limit.sync="sizePage1"
                  :page-sizes="[10, 15, 20, 30, 50]"
                  :class="isBdc ? 'bdc-table-pagination' : ''"
                />
              </bdc-table-footer>
              <el-table id="xiazaishijian" style="display: none;" :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" :data="tableData1" class="tb-edit tb-edit1">
                <el-table-column prop="dataKey" label="参数名" min-width="120" />
                <el-table-column prop="dataName" label="显示名" min-width="150" />
                <el-table-column prop="dataDesc" label="参数描述" min-width="200" />
                <el-table-column prop="ruleText" label="校验规则" min-width="120" />
                <el-table-column prop="dataType" label="数据类型" min-width="100">
                  <template slot-scope="scope">
                    {{ scope.row[scope.column.property] | dataTypes(dataTypeslist) }}
                  </template>
                </el-table-column>
                <el-table-column prop="sysType" label="属性类型" min-width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row.sysType == '1'">自定义属性</span>
                    <span v-if="scope.row.sysType == '0'">公共属性</span>
                    <span v-if="scope.row.sysType == '2'">虚拟属性</span>
                  </template>
                </el-table-column>
                <el-table-column prop="dataEmpty" label="是否必填" min-width="100">
                  <template slot-scope="scope">
                    {{ scope.row[scope.column.property] | dataEmptys }}
                  </template>
                </el-table-column>
                <el-table-column prop="isShow" label="显示状态" min-width="100">
                  <template slot-scope="scope">
                    <span v-if="scope.row[scope.column.property]">显示</span>
                    <span v-else>隐藏</span>
                  </template>
                </el-table-column>
                <el-table-column prop="status" label="是否生效" min-width="100">
                  <template slot-scope="scope">
                    {{ {0: '未生效', 1: '生效', 2: '添加中'}[scope.row[scope.column.property]] }}
                  </template>
                </el-table-column>
                <el-table-column prop="isCheck" label="必传校验" min-width="100">
                  <template slot-scope="scope">
                    <span v-if="scope.row[scope.column.property]">校验</span>
                    <span v-else>不校验</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 详情 -->
      <el-dialog :title="shijianxiangqing" :visible.sync="dialogTableVisible" custom-class="bdc-operate-aide-dialog" width="90%" top="8vh">

        <el-select v-model="tiaojian2.eventType" placeholder="事件类型" size="mini" style="float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" @change="eventshaixuaneventTypeselectshijian">
          <el-option label="全部事件" value="" />
          <el-option label="公共事件" value="0" />
          <el-option label="自定义事件" value="1" />
          <el-option label="必传参数" value="3" />
        </el-select>
        <el-input v-model="tiaojian2.findStr" size="mini" style="width:260px;float:left;margin-left:15px;margin-top:10px;margin-bottom:10px" placeholder="事件编码/事件显示名/事件描述模糊查询" clearable />
        <el-button type="primary" size="mini" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px" @click="mohuchaxun1">查询</el-button>

        <el-table v-loading="modelloading2" :stripe="!isBdc" :header-cell-style="isBdc ? undefined : {background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'0px 6px !important'}" :data="tableData2.slice((currentPage2-1)*sizePage2,currentPage2*sizePage2)" :class="isBdc ? 'grayTableTile bdc-crosshair-table' : 'tb-edit tb-edit1'" style="width: 100%; min-height:485px" border @filter-change="filterplatformType3" @sort-change="handleAgeSortChange" @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-form-item label="参数显示名">
                  <span>{{ props.row.dataName }}</span>
                </el-form-item>
                <el-form-item label="参数描述">
                  <span>{{ props.row.dataDesc }}</span>
                </el-form-item>
                <el-form-item label="参数校验规则">
                  <span>{{ props.row.ruleText }}</span>
                </el-form-item>
                <el-form-item label="字典关联名称">
                  <span>{{ props.row.dictType }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="eventCode" label="事件编码" min-width="100" sortable="custom" />
          <el-table-column prop="eventName" label="事件名称" min-width="120" sortable="custom" />
          <el-table-column prop="eventDesc" label="事件描述" show-overflow-tooltip min-width="200" sortable="custom" />
          <el-table-column prop="platformType" label="平台类型" min-width="120" :filters="[ { text: '服务端事件', value: '1' }, { text: '客户端事件', value: '2' }, { text: 'USDK埋点事件', value: '3' }]" :filter-multiple="false" column-key="platformType" filter-placement="bottom-end">
            <template slot-scope="scope">
              {{ scope.row[scope.column.property] | platformTypes }}
            </template>
          </el-table-column>
          <el-table-column prop="eventType" label="事件类型" min-width="100" :filters="[ { text: '公共事件', value: '0' }, { text: '自定义事件', value: '1' }, { text: '必传参数', value: '3' }]" :filter-multiple="false" column-key="eventType" filter-placement="bottom-end">
            <template slot-scope="scope">
              {{ scope.row[scope.column.property] | eventTypes }}
            </template>
          </el-table-column>
          <el-table-column prop="isShow" label="参数显示状态" min-width="100" :filters="[ { text: '显示', value:true }, { text: '隐藏', value: false }]" :filter-multiple="false" column-key="isShow" filter-placement="bottom-end">
            <template slot-scope="scope">
              <el-switch v-model="scope.row[scope.column.property]" active-color="#13ce66" inactive-color="#ff4949" @change="eventshowschange($event,scope.$index, scope.row,'eventData')" />
            </template>
          </el-table-column>
          <!-- 必传校验 -->
          <el-table-column prop="isCheck" label="参数必传校验" min-width="100" :filters="[{text: '校验', value: true}, {text: '不校验', value: false}]" :filter-multiple="false" column-key="isCheck" filter-placement="bottom-end">
            <template slot="header" slot-scope="scope">
              <span class="bdc-table-header-with-tip">
                必传校验
                <el-tooltip class="item" effect="dark" placement="right">
                  <div slot="content">用于标记属性是否为事件下的必传字段；<br />开启时，会在日志查看的格式校验中校验该属性是否上传；<br />关闭时，则不会校验，即事件中没有上传该属性也不会提示缺少参数。</div>
                  <span class="bdc-table-header-tip-trigger">
                    <bdc-help-icon />
                  </span>
                </el-tooltip>
              </span>
            </template>
            <template slot-scope="scope">
              <el-switch v-model="scope.row[scope.column.property]" active-color="#13ce66" inactive-color="#ff4949" @change="eventCheckchange($event,scope.$index, scope.row,'eventData')" :disabled="waiData.sysType != '1'" />
            </template>
          </el-table-column>

        </el-table>
        <bdc-table-footer>
          <pagination
            v-show="dataLength2 > 0"
            :auto-scroll="false"
            :background="!isBdc"
            :total="dataLength2"
            :page.sync="currentPage2"
            :limit.sync="sizePage2"
            :page-sizes="[10, 15, 20, 30, 50]"
            :class="isBdc ? 'bdc-table-pagination' : ''"
            @pagination="handleAttributeDetailPagination"
          />
        </bdc-table-footer>
      </el-dialog>

      <!-- 编辑自定义参数 -->
      <el-dialog :title="bianjititle" :visible.sync="updatedivifcanshu" custom-class="bdc-operate-aide-dialog" :close-on-click-modal="false" width="400px" top="5vh">
        <el-form ref="form" :inline="true" :model="csuform" label-width="120px">
          <el-form-item label="参数名">
            <el-input v-model="csuform.dataKey" disabled style="width:200px" />
          </el-form-item>
          <el-form-item label="参数类型">
            <el-select v-model="csuform.dataType" disabled placeholder="参数类型" size="small" style="margin-left:1px;width:230px;height:28px;line-height:28px;width:200px">
              <el-option v-for="selectvalue in dataTypeslist" :key="selectvalue.value" :label="selectvalue.text" :value="selectvalue.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="参数规则">
            <el-select v-model="csuform.ruleType" disabled placeholder="参数规则" size="small" style="margin-left:1px;width:230px;height:28px;line-height:28px;width:200px">
              <el-option v-for="selectvalue in ruleTypeslist" :key="selectvalue.value" :label="selectvalue.text" :value="selectvalue.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否必填">
            <el-switch v-model="csuform.dataEmpty" disabled active-value="1" inactive-value="0" active-color="#13ce66" inactive-color="#ff4949" />
          </el-form-item>
          <el-form-item label="参数描述">
            <el-input v-model="csuform.dataDesc" disabled type="textarea" style="width:200px" />
          </el-form-item>
          <el-form-item label="参数显示名">
            <el-input v-model="csuform.dataName" style="width:200px" />
          </el-form-item>
          <el-form-item label="显示状态">
            <el-switch v-model="csuform.isShow" active-color="#13ce66" inactive-color="#ff4949" />
            <el-tooltip class="item" effect="dark" content="显示状态" placement="right">
              <bdc-help-icon style="margin-left:20px;margin-bottom: 0px;" />
            </el-tooltip>
          </el-form-item>
          <!-- 必传校验 -->
          <el-form-item label="必传校验">
            <el-switch :disabled="csuform.sysType!='1'" v-model="csuform.isCheck" active-color="#13ce66" inactive-color="#ff4949" />
            <el-tooltip class="item" effect="dark" placement="right">
              <div slot="content">用于标记属性是否为事件下的必传字段；<br />开启时，会在日志查看的格式校验中校验该属性是否上传；<br />关闭时，则不会校验，即事件中没有上传该属性也不会提示缺少参数。</div>
              <bdc-help-icon style="margin-left:20px;margin-bottom: 0px;" />
            </el-tooltip>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer bdc-dialog-footer-actions">
          <el-button @click="updatedivifcanshu = false">取消</el-button>
          <el-button type="primary" @click="onSubmitcsuform">保存修改</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>
<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 100px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item__content {
  width: calc(100% - 120px);
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.el-table__expanded-cell {
  padding: 5px 10px !important;
}
</style>
<script>
import {
  ajax_eventdataqueryData,
  ajax_eventdataupdateShow,
  ajax_eventdataqueryEvent,
  ajax_eventupdateShow,
  ajax_eventupdateCheck,

  queryRuleList,
  queryTypeList
} from '@Bdc~/api/ajax_model'

import Pagination from '@/components/Pagination'
import BdcTableFooter from '@/components/BdcTableFooter'
import BdcDownloadButton from '@/components/BdcTableFooter/BdcDownloadButton'
import bdcTableCrosshair from '@Bdc~/utils/bdcTableCrosshair'
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'

export default {
  name: 'Metaevent',
  components: { Pagination, BdcTableFooter, BdcDownloadButton },
  mixins: [bdcTableCrosshair],
  computed: {
    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    }
  },
  filters: {
    delFlags(value) {
      if (value == '0') {
        return '显示'
      } else if (value == '1') {
        return '隐藏'
      }
    },
    platformTypes(value) {
      if (value == '1') {
        return '服务端事件'
      } else if (value == '2') {
        return '客户端事件'
      } else if (value == '3') {
        return 'USDK埋点事件'
      }
    },
    eventTypes(value) {
      if (value == '0') {
        return '公共事件'
      } else if (value == '3') {
        return '必传参数'
      } else if (value == '1') {
        return '自定义事件'
      }
    },
    eventDescsub(value) {
      if (value.length > 25) {
        return value.substring(0, 25) + '...'
      } else {
        return value
      }
    },
    eventNamesub(value) {
      if (value.length > 10) {
        return value.substring(0, 10) + '...'
      } else {
        return value
      }
    },
    dataEmptys(value) {
      if (value == '0') {
        return '否'
      } else if (value == '1') {
        return '是'
      }
    },

    dataTypes(value, arr) {
      for (var i = 0; i < arr.length; i++) {
        if (value == arr[i].value) {
          return arr[i].text
        }
      }
    },
    ispresets(value) {
      if (value == '0') {
        return '否'
      } else if (value == '1') {
        return '是'
      }
    }
  },
  data() {
    return {
      waiData: {},
      dialogTableVisible: false,
      shijianxiangqing: '',
      bjnametext: '',

      dataTypes: [],
      ruleTypes: [],
      dataTypeslist: [],
      ruleTypeslist: [],
      zdydialogTableVisible: false,
      zdyshijianxiangqing: '',

      bianjititle: '',
      updatedivifcanshu: false,
      csuform: {
        sasEventCode: '',
        dataKey: '',
        dataType: '',
        dataName: '',
        dataDesc: '',
        dataEmpty: '',
        isShow: true,
        ruleType: '',
        sysType: '',
        isCheck: true
      },

      tiaojian1: {
        eventType: '',
        isShow: '',
        appkey: this.$store.getters.appkey,
        dataType: '',
        status: '',
        findStr: '',
        dataEmpty: '',
        sysType: '',
        isCheck: ""
      },
      tiaojian2: {
        dataKey: '',
        eventType: '',
        isShow: '',
        appkey: this.$store.getters.appkey,
        findStr: '',
        platformType: '',
        isCheck: ""
      },

      tableData1: [],
      tableData1copy: [],
      currentPage1: 1,
      dataLength1: 1,
      sizePage1: 10,

      tableData2: [],
      tableData2copy: [],
      currentPage2: 1,
      dataLength2: 1,
      sizePage2: 10,

      modelloading: false,
      modelloading1: false,
      modelloading2: false

    }
  },
  created() {
    this.queryEventList()
    this.queryRuleList()
    this.queryTypeList()
  },
  mounted() { },
  methods: {
    bianjishijianshuxing(index, row) {
      this.bianjititle = row.dataKey
      this.updatedivifcanshu = true
      this.csuform = {
        dataKey: row.dataKey,
        dataType: row.dataType + '',
        dataName: row.dataName,
        dataDesc: row.dataDesc,
        dataEmpty: row.dataEmpty,
        isShow: row.isShow,
        sysType: row.sysType,
        ruleType: row.ruleType + '',
        isCheck: row.isCheck
      }
    },
    onSubmitcsuform() {
      var datas = {
        appkey: this.$store.getters.appkey,
        dataKey: this.csuform.dataKey,
        isShow: this.csuform.isShow,
        dataName: this.csuform.dataName,
        isCheck: this.csuform.isCheck,
      }
      ajax_eventdataupdateShow(datas).then(response => {
        if (response.code == 1) {
          this.$message.success(response.msg)
          this.queryEventList()
        }
        this.updatedivifcanshu = false
      })
    },
    bianjiname(index, row) {
      var datas = {
        appkey: this.$store.getters.appkey,
        dataKey: row.dataKey,
        isShow: row.isShow,
        dataName: this.bjnametext,
        isCheck: row.isCheck,
      }

      ajax_eventdataupdateShow(datas).then(response => {
        if (response.code == 1) {
          this.$message.success(response.msg)
          this.queryEventList()
        }
      })
    },
    bianjixianshi(e, index, row) {
      var datas = {
        appkey: this.$store.getters.appkey,
        dataKey: row.dataKey,
        isShow: e,
        dataName: row.dataName,
        isCheck: row.isCheck,
      }
      ajax_eventdataupdateShow(datas).then(response => {
        if (response.code == 1) {
          this.$message.success(response.msg)
          this.queryEventList()
        }
      })
    },

    bianjiCheck(e, index, row) {
      var datas = {
        appkey: this.$store.getters.appkey,
        dataKey: row.dataKey,
        isShow: row.isShow,
        dataName: row.dataName,
        isCheck: e,
      }
      ajax_eventdataupdateShow(datas).then(response => {
        if (response.code == 1) {
          this.$message.success(response.msg)
          this.queryEventList()
        }
      })
    },

    eventCheckchange(e, index, row, type) {
      var datas = {
        type: type,
        id: row.id,
        isCheck: e
      }
      ajax_eventupdateCheck(datas).then(
        response => {
          if (response.code == 1) {
            this.$message.success(response.msg)
          }
          this.queryEventDataList()
          this.queryEventList()
        }
      )
    },
    eventshowschange(e, index, row, type) {
      var datas = {
        type: type,
        id: row.id,
        isShow: e
      }
      ajax_eventupdateShow(datas).then(
        response => {
          if (response.code == 1) {
            this.$message.success(response.msg)
          }
          this.queryEventDataList()
        }
      )
    },
    queryEventList() {
      // 列表
      this.modelloading2 = true
      console.log(this.tiaojian1)
      ajax_eventdataqueryData(this.tiaojian1).then(
        response => {
          console.log(response)
          if (response.code == 1) {
            this.tableData1 = response.data
            this.tableData1copy = JSON.parse(JSON.stringify(response.data))
            this.dataLength1 = response.data.length
          }
          this.modelloading2 = false
        }
      )
    },
    queryEventDataList() {
      // 详情
      ajax_eventdataqueryEvent(this.tiaojian2).then(response => {
        console.log(response)
        if (response.code == 1) {
          this.tableData2 = response.data
          this.tableData2copy = JSON.parse(JSON.stringify(response.data))
          this.dataLength2 = response.data.length
        }
      })
    },
    queryRuleList() {
      // 自定义事件参数规则
      queryRuleList().then(response => {
        console.log('自定义事件参数规则', response)
        if (response.code == 1) {
          this.ruleTypes = response.data
          for (var i = 0; i < response.data.length; i++) {
            this.ruleTypeslist.push({
              text: response.data[i].ruleText,
              value: response.data[i].ruleType
            })
          }
        }
      })
    },
    queryTypeList() {
      // 自定义事件参数类型
      queryTypeList().then(response => {
        console.log('自定义事件参数类型', response)
        if (response.code == 1) {
          this.dataTypes = response.data
          for (var i = 0; i < response.data.length; i++) {
            this.dataTypeslist.push({
              text: response.data[i].dataTypeName,
              value: response.data[i].dataType
            })
          }
        }
      })
    },
    chakanxiangqing(index, row) {
      this.waiData = row
      // 查看事件详情
      this.dialogTableVisible = true
      this.shijianxiangqing = '包含【' + row.dataKey + '】的事件列表'
      this.tiaojian2.dataKey = row.dataKey
      this.queryEventDataList()
    },
    filterplatformType(filters) {
      // 筛选所选项下的所有数据，需要调用后端接口
      console.log(filters)
      if (filters.dataType) {
        if (filters.dataType.length > 0) {
          this.tiaojian1.dataType = filters.dataType[0]
        } else {
          this.tiaojian1.dataType = ''
        }
      }
      if (filters.status) {
        console.log(111)
        if (filters.status.length > 0) {
          this.tiaojian1.status = filters.status[0]
        } else {
          this.tiaojian1.status = ''
        }
        console.log(this.tiaojian1)
      }

      if (filters.sysType) {
        if (filters.sysType.length > 0) {
          this.tiaojian1.sysType = filters.sysType[0]
        } else {
          this.tiaojian1.sysType = ''
        }
      }
      if (filters.eventType) {
        if (filters.eventType.length > 0) {
          this.tiaojian1.eventType = filters.eventType[0]
        } else {
          this.tiaojian1.eventType = ''
        }
      }

      if (filters.dataEmpty) {
        if (filters.dataEmpty.length > 0) {
          this.tiaojian1.dataEmpty = filters.dataEmpty[0]
        } else {
          this.tiaojian1.dataEmpty = ''
        }
      }

      if (filters.isShow) {
        if (filters.isShow.length > 0) {
          this.tiaojian1.isShow = filters.isShow[0]
        } else {
          this.tiaojian1.isShow = ''
        }
      }

      if (filters.isCheck) {
        if (filters.isCheck.length > 0) {
          this.tiaojian1.isCheck = filters.isCheck[0]
        } else {
          this.tiaojian1.isCheck = ''
        }
      }
      console.log(this.tiaojian1)
      this.currentPage1 = 1
      this.queryEventList()
    },
    filterplatformType3(filters) {
      // 筛选所选项下的所有数据，需要调用后端接口
      console.log(filters.platformType)
      if (filters.platformType) {
        if (filters.platformType.length > 0) {
          this.tiaojian2.platformType = filters.platformType[0]
        } else {
          this.tiaojian2.platformType = ''
        }
      }

      if (filters.eventType) {
        if (filters.eventType.length > 0) {
          this.tiaojian2.eventType = filters.eventType[0]
        } else {
          this.tiaojian2.eventType = ''
        }
      }

      if (filters.isShow) {
        if (filters.isShow.length > 0) {
          this.tiaojian2.isShow = filters.isShow[0]
        } else {
          this.tiaojian2.isShow = ''
        }
      }

      if (filters.isCheck) {
        if (filters.isCheck.length > 0) {
          this.tiaojian2.isCheck = filters.isCheck[0]
        } else {
          this.tiaojian2.isCheck = ''
        }
      }
      this.currentPage2 = 1
      this.queryEventDataList()
    },
    eventshaixuaneventTypeselect(e) {
      this.currentPage1 = 1
      this.queryEventList()
    },
    eventshaixuaneventTypeselectshijian(e) {
      this.tiaojian2.eventType = e
      this.currentPage2 = 1
      this.queryEventDataList()
    },
    mohuchaxun() {
      this.currentPage1 = 1
      this.queryEventList()
    },
    mohuchaxun1() {
      this.currentPage2 = 1
      this.queryEventDataList()
    },
    handleAgeSortChange(e) {
      console.log(e)
      if (e.order == 'ascending') {
        var order = true
      } else if (e.order == 'descending') {
        var order = false
      }
      if (e.order == null) {
        this.tableData2 = JSON.parse(JSON.stringify(this.tableData2copy))
      } else {
        this.tableData2.sort(this.sortBy(e.prop, order))
      }
    },
    handleAgeSortChangeeventdata(e) {
      console.log(e)
      if (e.order == 'ascending') {
        var order = true
      } else if (e.order == 'descending') {
        var order = false
      }
      if (e.order == null) {
        this.tableData1 = JSON.parse(JSON.stringify(this.tableData1copy))
      } else {
        this.tableData1.sort(this.sortBy(e.prop, order))
      }
    },
    sortBy(attr, rev) {
      // 第二个参数没有传递 默认升序排列
      if (rev == undefined) {
        rev = 1
      } else {
        rev = rev ? 1 : -1
      }

      return function (a, b) {
        // a = a[attr];
        // b = b[attr];
        if (!isNaN(Number(a[attr])) && !isNaN(Number(b[attr]))) {
          a = Number(a[attr])
          b = Number(b[attr])
        } else {
          a = a[attr]
          b = b[attr]
        }

        if (a < b) {
          return rev * -1
        }
        if (a > b) {
          return rev * 1
        }
        return 0
      }
    },
    handleSizeChange1(e) {
      // table 分页数量变化
      this.sizePage1 = e
    },
    handleCurrentChange1(e) {
      // table 分页变化
      this.currentPage1 = e
    },
    handleAttributeDetailPagination({ page, limit }) {
      const pageSizeChanged = limit !== this.sizePage2
      this.sizePage2 = limit
      this.currentPage2 = pageSizeChanged ? 1 : page
    },
    exportExcel(e) {
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(document.querySelector('#xiazaishijian'))
      /* get binary string as output */
      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '事件属性列表.xlsx')
      } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
      return wbout
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  padding: 10px 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
  background-color: #f0efef;
}
.ibox-title {
  line-height: 32px;
  padding: 4px 15px 3px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
  font-size: 12px !important;
}
/* .el-table th{background:#fff;} */
</style>

<style>
.el-dialog__body {
  padding: 10px 5px;
}
.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.tb-edit1 tr td .cell {
  padding: 0px 10px !important;
}

.el-table:not(.grayTableTile) th {
  background-color: #fff;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
</style>
<style  lang="scss" scoped>
.bianjisty {
  position: absolute;
  right: 5px;
  top: 6px;
  width: 25px;
  font-size: 16px;
  opacity: 0;
}
.cell:hover {
  .bianjisty {
    opacity: 1;
  }
}
.cell div {
  height: 20px;
  line-height: 20px;
}
</style>
